import { render, staticRenderFns } from "./TeacherLeaveForm.vue?vue&type=template&id=381bb7b6"
import script from "../../../controllers/common/teacher_leave/teacher-leave-form.js?vue&type=script&lang=js&external"
export * from "../../../controllers/common/teacher_leave/teacher-leave-form.js?vue&type=script&lang=js&external"
import style0 from "./TeacherLeaveForm.vue?vue&type=style&index=0&id=381bb7b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports